import { GISPoint, GISPolygon, GISPolyline, GeometryType, Geometry } from "../models/geometry.model";

export class GeometryFactory {
    static CreateGeometry(obj: any & { type: GeometryType }, context?: any): Geometry<any> {
        switch (obj.type) {
            case GeometryType.Point:
                return new GISPoint(obj, context);
            case GeometryType.polygon:
                return new GISPolygon(obj, context);
            case GeometryType.polyline:
                return new GISPolyline(obj, context);
        }
    }
}